import { Route, Routes } from "react-router-dom"
import { Home } from "../../UiMaster/Home/Home"
import { GridGenerator } from '../../UiMaster/GridGenerator/GridGenerator'
import { QRGenreator } from "../../UiMaster/QRGenreator/QRGenreator"
import { Selector } from "../../UiMaster/Selector/Selector"


export const UiMasterRouter = () => {


    return (
        <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path='/GridGenerator' element={<GridGenerator />}></Route>
            <Route path='/QRGenreator' element={<QRGenreator />}></Route>
            <Route path='/Selector' element={<Selector />}></Route>
        </Routes>
    )
}